// src/pages/Login.js (Revised)
import { ForgotPasswordForm, LoginForm } from "../elements/login";
import { Text, Title } from "../components/typography";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { PassResetState } from "../redux/user"; // Ensure this is a valid Redux action creator
import { responsiveness } from "../assets/styles/parameters";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const Login = () => {
  const [passReq, setPassReq] = useState(false);
  const { error, userInfo } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo?.token) {
      navigate("/");
    }
  }, [userInfo, navigate]);

  const showAlert = useCallback(() => {
    toast.warning("Logged out because of inactivity");
    window.history.replaceState({}, document.title, "/");
  }, []);

  const onShowResetForm = useCallback(() => {
    dispatch(PassResetState()); // 👈 Correctly call the action creator
    setPassReq((prev) => !prev);
  }, [dispatch]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loggedout = urlParams.get("loggedout");

    if (loggedout) {
      showAlert();
    }
  }, [showAlert]);

  return (
    <BaseHeader>
      <div>
        <Title>Corbin Ford</Title>
        {!passReq ? (
          <LoginForm setPassReq={onShowResetForm} error={error} />
        ) : (
          <ForgotPasswordForm setPassReq={onShowResetForm} />
        )}
        <BaseFooterSub scale="sm">
          &copy; Copyright
          <span className="year">{new Date().getFullYear()} </span>Corbin Ford -
          All Rights Reserved
        </BaseFooterSub>
      </div>
    </BaseHeader>
  );
};

const BaseHeader = styled.header`
  height: 100dvh;
  display: flex;
  justify-content: center;

  & > div {
    padding: 1rem 3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 40%;
    align-items: center;
  }

  @media screen and (max-width: ${responsiveness.mobile1}) {
    grid-template-columns: 1fr;
    grid-auto-flow: dense;

    div:first-child {
      padding: 1rem;
      width: 100%;
    }
  }
`;

const BaseFooterSub = styled(Text)`
  font-size: 0.5rem;
  padding: 0;
  margin: 4rem 0 0 0;
  text-align: center;
`;
